import produce from 'immer';
import { GET_USER_FAILURE, GET_USER_REQUEST, GET_USER_SUCCESS, USER_NAME_UPDATE_FAILURE, USER_NAME_UPDATE_REQUEST, USER_NAME_UPDATE_SUCCESS, GET_USER_PERMISSIONS_FAILURE, GET_USER_PERMISSIONS_REQUEST, GET_USER_PERMISSIONS_SUCCESS, } from './constants';
export var initialState = {
    user: {},
    meta: {},
    permissions: {},
    loading: false,
    loadingError: false,
    updating: false,
    updateError: false,
    templateLoading: false,
    templateError: false,
    loadingPermissions: false,
    permissionError: false,
};
function userEditReducer(currentState, action) {
    if (currentState === void 0) { currentState = initialState; }
    return produce(currentState, function (state) {
        switch (action.type) {
            case GET_USER_REQUEST:
                state.loading = true;
                state.error = false;
                break;
            case GET_USER_SUCCESS:
                state.loading = false;
                state.error = false;
                state.user = action.user;
                break;
            case GET_USER_FAILURE:
                state.loading = false;
                state.error = true;
                break;
            case USER_NAME_UPDATE_REQUEST:
                state.updating = true;
                state.updateError = false;
                break;
            case USER_NAME_UPDATE_SUCCESS:
                state.updating = false;
                state.updateError = false;
                state.user.groups = action.addedGroup;
                break;
            case USER_NAME_UPDATE_FAILURE:
                state.updating = false;
                state.updateError = true;
                break;
            case GET_USER_PERMISSIONS_REQUEST:
                state.loadingPermissions = true;
                state.permissionError = false;
                break;
            case GET_USER_PERMISSIONS_SUCCESS:
                state.permissions = action.permissions;
                state.loadingPermissions = false;
                state.permissionError = false;
                break;
            case GET_USER_PERMISSIONS_FAILURE:
                state.loadingPermissions = false;
                state.permissionError = action.error;
                break;
            default:
                break;
        }
    });
}
export default userEditReducer;
